exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".menu-list[data-v-73ac2fec]{-webkit-transition:height .333s ease;transition:height .333s ease;display:block;overflow-y:hidden;overflow-x:hidden}.menu-list li>ul[data-v-73ac2fec]{margin:0 0 0 .5rem;padding-left:0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-73ac2fec","scoped":true,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/js/core/structure/menu/Menus.vue
// module id = JCfe
// module chunks = 66